// Originally from https://github.com/sindresorhus/escape-string-regexp/blob/master/index.js
// The owner refuses to supply as ES5 on grounds that it is intended for node.js. He also
// refuses to mention in the docs that it is intended for node, so it breaks IE11 for many people.
export default function escapeRegExp(string) {
  if (typeof string !== 'string') {
    throw new TypeError('Expected a string');
  } // Escape characters with special meaning either inside or outside character sets.
  // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.


  return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
//# sourceMappingURL=escapeRegExp.js.map